var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gcash-success"},[_c('app-gcash-success-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }